import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootStore from 'src/app/_apps/root/store';
import { ColoredPopupMenuItem } from '../../cog/colored-popup-menu-item.model';

@Component({
    selector: 'aa-colored-popup-menu-item',
    templateUrl: './colored-popup-menu-item.component.html',
    styleUrls: [
        '../../popup-menu-item/popup-menu-item.component.scss',
        './colored-popup-menu-item.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColoredPopupMenuItemComponent implements OnInit
{
    @Input() popupMenuItem: ColoredPopupMenuItem;
    @Input() typePopup: string;
    text: string;

    constructor (
        private translate: TranslateService,
        private store: Store<IAuroraState>
    )
    { }

    ngOnInit ()
    {
        this.text = this.translate.instant(this.popupMenuItem.key);
    }

    ctaClick (event: MouseEvent)
    {
        this.popupMenuItem.cta(event);
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootPopupMenuItemClicked());
    }

    linkClick ()
    {
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootPopupMenuItemClicked());
    }

    redirect (href: string)
    {
        window.location.href = href;
    }
}
